import { Card, Text, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from './FeatureCards.module.css';

/**
 * White bordered pillar card for marketing home sections.
 *
 * @param {object} props
 * @param {import('@tabler/icons-react').Icon} props.icon
 * @param {string} props.titleKey
 * @param {string} props.descriptionKey
 */
export function MarketingPillarCard({ icon: Icon, titleKey, descriptionKey }) {
  const { t } = useTranslation('common');
  const theme = useMantineTheme();

  return (
    <Card
      shadow="sm"
      radius="md"
      withBorder
      className={classes.card}
      padding="xl"
      bg="white"
    >
      <Icon size={50} stroke={2} color={theme.colors.pachubColourScheme[6]} />
      <Text fz="lg" fw={500} className={classes.cardTitle} mt="md">
        {t(titleKey)}
      </Text>
      <Text fz="sm" c="dimmed" mt="sm">
        {t(descriptionKey)}
      </Text>
    </Card>
  );
}
